import React, { FC } from 'react';
import styled from 'styled-components';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import { Collector } from '../../models/Collector';

const MapWrapper = styled.div`
    flex: 1;
    height: 500px;
    
    @media screen and (max-width: 768px) {
        background: white;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        height: 300px;
    }
`;

interface Props {
  collector: Collector;
}

export const CollectorMapWidget: FC<Props> = ({ collector }) => (
  <MapWrapper>
    <MapContainer
      style={{ width: '100%', height: '100%' }}
      center={[collector.latitude, collector.longitude]}
      zoom={13}
      scrollWheelZoom
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[collector.latitude, collector.longitude]} />
    </MapContainer>
  </MapWrapper>
);
